import React from 'react'

import styles from './Loader.module.scss'

type LoaderProps = {
  size: 'small' | 'medium' | 'large' | 'full'
}

export const Loader = (props: LoaderProps): JSX.Element => {
  return (
    <div className={`${styles.loader} ${styles[`loader_${props.size}`]}`}></div>
  )
}
